import { request } from '@/utils/request'
import { rsaEncryptCode } from '@/utils/encrypt'

export const login = (data) => request('/sql/common/login', data, 'post')

export const logout = (token) => request('/sql/common/logout', { token }, 'get')

export const cookieLogin = (productCode = 'TDS') => request('/sql/common/loginByCookie', { productCode }, 'get')

export const ipLogin = (productCode = 'TDS') => request('/sql/common/loginByIp', { productCode }, 'get')

export const guestLogin = (productCode = 'TDS') => request('/sql/common/loginByGuest', { productCode }, 'get')
// 网络登录
export const netLogin = (netStr, productCode = 'TDS') => request(`/sql/common/loginByNST?productCode=${productCode}&` + netStr, {}, 'get')

// 短信登录
export const loginByPhone = (params) => request('/sql/common/loginByPhone', params, 'post')
// 获取短信验证码
export const validateCodePhoneApi = (phone) => request('/sql/common/validateCodePhone', { phone })
//获取邮箱验证码
export const validateCodeEmailApi = (email) => request('/sql/common/validateCodeEmail', { email }, 'get')
// 注册
export const register = (params) => request('/sql/common/register', params, 'post')

/* 微信登录相关 */
// 获取二维码图片
export const getQrCodeImg = () => request('/sql/common/weixinLoginParam', { productCode: 'TDS' }, 'get')
// 获取二维码状态
export const getQrStatus = (cid) => request('/sql/common/weixin/auth/status', { cid }, 'get')
// 微信的登录
export const loginByWx = (cid) => request('/sql/common/loginByWeixin', { cid, productCode: 'TDS' }, 'get')

/* 找回密码 */
export const findPwdByPhone = (data) => request('/sql/common/login/findPwdByPhone', data, 'post')
export const findPwdByEmail = (data) => request('/sql/common/login/findPwdByEmail', data, 'post')

/* 校验账号是否存在 */
export const checkExist = (prams) => request('/sql/common/checkExist', prams, 'get')

//获取秘钥
export const getRSABase64PublicKey = () => request('/sql/common/getRSABase64PublicKey', {}, 'get')

export const getValidateCodeApi = () => request('/sql/common/validateCode', {}, 'get')
//获取用户信息
export const getUserinfo = (isGuestLogin) => request('/sql/access/getUserInfo', {}, 'get', isGuestLogin)

//获取用户头像
export const getUserImg = () => request('/sql/access/getUserWxHeadImg', {}, 'get')

export const getIp = () => request('/sql/common/getIpAddr', {}, 'get')

export const getContent = (data) => request('/std/data/getContent', data, 'get')

//获取产品模块静态数据
export const getProductDataApi = (data) => request('/sql/access/getProductStaticData', data)

export const getIndexData = (moduleCode) => request('/tds/data/searchModuleDataList', { moduleCode }, 'get')

//微信支付
export const auth = (code) => request('/pay/data/login?code=' + code, {}, 'get')

export const wxAuth = (code, state) => request('/sql/common/weixin/auth?code=' + code + '&state=' + state, {}, 'get')

export const getPayParamInfo = () => request('/pay/common/payInfo', {}, 'get')

export const getOrderInfo = (orderNo) => request('/pay/common/orderInfo?orderNo=' + orderNo, {}, 'get')

export const queryOrder = (orderNo) => request('/pay/common/wx/orderquery?orderNo=' + orderNo, {}, 'get')

export const wxH5Prepay = (data) => request('/pay/common/wx/prepay/h5', data, 'post')
export const reWxH5Pay = (data) => request('/pay/common/wx/prepay/h5', data, 'post')

export const getStatistics = () => request('/sql/access/getUpdateInfo')

export const getTopicDataApi = (data) => request('/tds/data/getTopicData', data)

//更新数据
export const initUpdateInfo = () => request('/sql/access/initUpdateInfo', {}, 'get')

//用户行为埋点
export const addUserBehaviorApi = (data) => request('/sql/access/addUserBehavior',data, 'post')
